import type { PageIntroHeadingLevel } from './PageIntro.types'

/** Nivel de encabezado por defecto: `<h1>` (encabezado principal de la página). */
export const DEFAULT_HEADING_LEVEL: PageIntroHeadingLevel = 1

/** Etiqueta accesible del breadcrumb. */
export const BREADCRUMB_LABEL = 'Ruta de navegación'

/** Locale para formatear el contador. */
export const COUNTER_LOCALE = 'es-ES'
